"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shadows = void 0;
exports.shadows = [
    "none",
    /** ButtonBar shadow */
    "0px 6px 10px 0px rgba(0,0,0,0.07)",
    /** Explorer items */
    "0px 4px 4px 0px rgba(0,0,0,0.1)",
    /** LeftBar */
    "6px 0px 16px 0px rgba(0,0,0,0.15)",
    /** AccountTab default */
    "4px 0px 10px 0px rgba(0,0,0,0.07)",
    /** AccountTab active */
    "-4px 0px 10px 0px rgba(0,0,0,0.07)",
    /** Card over */
    "0px 6px 10px 0px rgba(0,0,0,0.14)",
    /** Dialog **/
    "0px 8px 10px -7px rgba(0,0,0,0.07)",
];
//# sourceMappingURL=shadows.js.map